export const APP_DATE_FORMAT = 'D. M. YYYY';
export const TAX = 0.15;
export const RETURN_PERIOD_DATE_FORMAT = 'M/YYYY';
export const RETURN_PERIOD_NAME_DELIMITER = ' ';
export const OWNERSHIP_LIST_DATE_FORMAT = 'DD. MM. YYYY';
export const RETURN_PERIOD_FROM_STRAPI_FORMAT = 'YYYY-MM-DD';
